var INPUT_MULTIPLE_STATE;
(function (INPUT_MULTIPLE_STATE) {
    INPUT_MULTIPLE_STATE["DEFAULT"] = "default";
    INPUT_MULTIPLE_STATE["ERROR"] = "error";
    INPUT_MULTIPLE_STATE["DISABLED"] = "disabled";
    INPUT_MULTIPLE_STATE["LOADING"] = "loading";
    INPUT_MULTIPLE_STATE["READ_ONLY"] = "read-only";
    INPUT_MULTIPLE_STATE["SUCCESS"] = "success";
})(INPUT_MULTIPLE_STATE || (INPUT_MULTIPLE_STATE = {}));
var LINK_TARGET;
(function (LINK_TARGET) {
    LINK_TARGET["Blank"] = "_blank";
    LINK_TARGET["Self"] = "_self";
    LINK_TARGET["Parent"] = "_parent";
    LINK_TARGET["Top"] = "_top";
})(LINK_TARGET || (LINK_TARGET = {}));

export { INPUT_MULTIPLE_STATE as I, LINK_TARGET as L };
